__turbopack_context__.v({
  "section": "JenYkq_section",
  "section__address": "JenYkq_section__address",
  "section__contact": "JenYkq_section__contact",
  "section__logo": "JenYkq_section__logo",
  "section__logo-wrapper": "JenYkq_section__logo-wrapper",
  "section__phone": "JenYkq_section__phone",
  "section__title": "JenYkq_section__title",
});
